var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36C555",
    d: "M8.5 0C3.825 0 0 3.825 0 8.5S3.825 17 8.5 17 17 13.175 17 8.5 13.175 0 8.5 0Zm0 15.3a6.809 6.809 0 0 1-6.8-6.8c0-3.748 3.051-6.8 6.8-6.8 3.748 0 6.8 3.051 6.8 6.8 0 3.748-3.052 6.8-6.8 6.8Zm4.503-9.951a.85.85 0 0 0-1.205-.003L6.8 10.345 5.198 8.75A.848.848 0 0 0 4 9.949l2.446 2.447a.5.5 0 0 0 .708 0L13 6.55a.85.85 0 0 0 .002-1.2Z"
  })));
};
export default SvgSuccess;